<template>
    <div>
        <div class="col-12 row my-3">
            <a :href="return_route" class="mr-auto ml-2">
                <button class="btn btn-default float-right" type="button">{{ $lang('Wróć') }}</button>
            </a>
            <button type="button" class="btn btn-primary ml-auto mr-0"
                    data-toggle="modal" data-target="#new_comment">{{$lang('Nowy komentarz')}}
            </button>
        </div>

        <new-comment-modal
            :url="create_route"
        ></new-comment-modal>
        <div class="form-row col-12">
            <div v-for="comment in comments" class="card col-12 p-0 mt-3">
                <div class="card-header pt-1 pb-1">
                    <div class="row">
                        <div class="col-6">{{comment.name}}</div>
                        <div class="pull-right col-6">
                            <div class="row">
                                <div class="ml-auto mr-4">
                                    <i class="fa fa-trash tile icon fa-lg print" v-if="comment.can_remove"
                                       @click="deleteComment(comment.id)" aria-hidden="true"></i>
                                </div>
                                <div class="mr-2">
                                    <i class="fa fa-pencil tile icon fa-lg print" aria-hidden="true"
                                       data-toggle="modal" data-target="#edit_comment"
                                       @click="editedComment=comment"></i>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="card-body">
                    {{comment.content}}
                </div>
            </div>
            <edit-comment-modal
                :url="update_route"
                :comment=editedComment
            ></edit-comment-modal>
        </div>
    </div>
</template>

<script>
    import EditCommentModal from "./edit-comment-modal";
    import NewCommentModal from "./new-comment-modal";

    export default {
        name: "comments-index",
        components: {NewCommentModal, EditCommentModal},
        props: {
            return_route: String,
            comments: Array,
            create_route: String,
            update_route: String,
            delete_route: String,
        },
        data() {
            return {
                editedComment: null
            }
        },
        methods: {
            deleteComment(id) {
                axios.post(this.delete_route, {
                    id: id
                })
                    .then(function () {
                        location.reload();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }
    }
</script>
